<resource-list-grid>
    <resource-list-pane>
        <h2>Okta SSO processing</h2>
    </resource-list-pane>
</resource-list-grid>